import type { CustomIconProps } from '../types';

const LoadingWheel = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 0.923077C3.19609 0.923077 0.923077 3.19609 0.923077 6C0.923077 8.80391 3.19609 11.0769 6 11.0769C6.2549 11.0769 6.46154 11.2836 6.46154 11.5385C6.46154 11.7934 6.2549 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 6.2549 11.7934 6.46154 11.5385 6.46154C11.2836 6.46154 11.0769 6.2549 11.0769 6C11.0769 3.19609 8.80391 0.923077 6 0.923077Z"
            fill="#414042"
        />
    </svg>
);

export default LoadingWheel;
